<template>
  <div>
    <navbar :links="['dashboard', $route.name]" />
    <div
      v-if="!$user"
      class="loading-indicator"
    >
      <v-progress-circular
        :size="50"
        indeterminate
        class="mt-5 msr--text"
      />
    </div>
    <span v-else>
      <!-- Router buttons that look like tabs -->
      <v-layout
        class="mt-3"
        :justify-center="$vuetify.breakpoint.xs"
      >
        <v-btn
          v-if="$store.getters.isUsermanagerOrManagedCoadmin"
          flat
          class="black--text ml-0"
          style="border-bottom: 2px solid var(--msr-color-primary)"
          :block="$vuetify.breakpoint.xs"
        >{{
          $vuetify.breakpoint.xsOnly
            ? $t('userManagementInviteNewShort')
            : $t('userManagementInviteNew')
        }}</v-btn>
        <v-btn
          flat
          class="black--text ml-0"
          style="opacity: 0.65"
          to="/users/manage"
          :block="$vuetify.breakpoint.xs"
        >
          <v-badge
            color="msr"
            class="nudged-right"
          >
            <span
              v-if="managedUsers.length > 0"
              slot="badge"
              :style="{'font-size': managedUsers.length > 9 ? '13px' : '14px'}"
            >{{ managedUsers.length + 1 }}</span>
            {{
              $vuetify.breakpoint.xsOnly
                ? manageUsersTabTitleShort
                : manageUsersTabTitle
            }}
          </v-badge>
        </v-btn>
      </v-layout>
      <invite-users
        v-if="$store.getters.isUsermanagerOrManagedCoadmin"
        class="mt-3"
      />
    </span>
  </div>
</template>

<script>
import commonUsermanagement from '@/mixins/commonUsermanagement.js';

import InviteUsers from '@/components/UserManagement/InviteUsers';
import Navbar from '@/components/Navbar';

export default {
  components: {
    InviteUsers,
    Navbar,
  },
  mixins: [commonUsermanagement],
  created() {
    this.fetchUserDataAsNeeded();
  },
  methods: {
    /**
     * This page needs the current User and its managed Users to work.
     *
     * That information may not yet be available when e.g. reloaded in
     * the browser, in that case we fetch it here.
     */
    fetchUserDataAsNeeded() {
      if (!this.$user) {
        this.$store.dispatch('RETRIEVE_CURRENT_USER');
      }
      if (!this.managedUsers.length) {
        this.$store.dispatch('LIST_MANAGED_USERS');
      }
    },
  },
};
</script>

<style scoped>
.nudged-right >>> .v-badge__badge {
  right: -26px;
}
</style>



// WEBPACK FOOTER //
// src/pages/UserManagementInvite.vue